module.exports = __webpack_public_path__ + "img/odometer.bd0df021.svg";